module.exports = __webpack_public_path__ + "static/media/ic_theme_cross_border.84fdb160.svg";